export default {
	"a1016e95e32bb52f09c8f1d28c2ed6d1": "The goods are sold out. Please reselect the items to redeem",
	"dd7c1a8f6562b64472dc9f43e2219abb": "I see."
}
